import React from "react";

import styled from "styled-components/macro";

import { NavLink, useParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

import {
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";

import { MastraService } from "../../services";

import { extractMessageText } from "../../utils/mastraMessage";

const Box = styled(MuiBox)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

export const ConversationMessagesPage = () => {
  const [messages, setMessages] = React.useState([]);

  const { threadId } = useParams();

  React.useEffect(() => {
    (async () => {
      const resList = await MastraService.listThreadMessages(threadId);
      setMessages(resList.data);
    })();
  }, [threadId]);

  return (
    <Box p={8}>
      <Helmet title="Mensagens da Conversa" />

      <Grid justify="space-between" container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Mensagens
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Inicio
            </Link>
            <Link component={NavLink} exact to="/platform/conversations">
              Conversas
            </Link>
            <Typography>Mensagens</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <div>
            <Paper>
              <TableContainer>
                <Table aria-labelledby="tableTitle" size={"medium"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>PAPEL</TableCell>
                      <TableCell>TIPO</TableCell>
                      <TableCell>CONTEÚDO</TableCell>
                      <TableCell>CRIADO EM</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {messages?.map((row, index) => {
                      return (
                        <TableRow>
                          <TableCell align="left" id={index} scope="row">
                            <strong>{row.role}</strong>
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.type}
                          </TableCell>

                          <TableCell
                            align="left"
                            id={index}
                            scope="row"
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {extractMessageText(row.content)}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.createdAt &&
                              format(parseISO(row.createdAt), "PPPP 'às' p", {
                                locale: pt,
                              })}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
